// Helper functions for SearchWatchdogModal

/**
 * Validates email address format
 */
export const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailRegex.test(email.trim());
};

/**
 * Handles editing query by closing modal and focusing search input
 */
export const handleEditQuery = (onClose: () => void): void => {
    // Zavřít modal
    onClose();

    // Po malém zpoždění simulovat kliknutí do vyhledávacího pole
    setTimeout(() => {
        const searchInput = document.querySelector<HTMLInputElement>("#search-input");

        if (searchInput !== null) {
            // Simulovat kliknutí pro otevření vyhledávací komponenty
            const clickEvent = new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                view: window,
            });

            searchInput.dispatchEvent(clickEvent);

            // Také aktivovat fokus a vybrat text
            searchInput.focus();
            searchInput.select();
        }
    }, 100);
};

/**
 * Transforms API response from snake_case to camelCase
 */
export const transformApiResponse = (apiResponse: Record<string, unknown>): {
    query: string;
    correctedQuery?: string;
    totalHits: number;
} => ({
    query: typeof apiResponse.query === "string" ? apiResponse.query : "",
    correctedQuery: typeof apiResponse.corrected_query === "string" ? apiResponse.corrected_query : undefined,
    totalHits: typeof apiResponse.total_hits === "number" ? apiResponse.total_hits : 0,
});

/**
 * Resets all modal state to initial values
 */
export const getInitialModalState = (): {
    loading: boolean;
    errorMessage: undefined;
    searchResults: undefined;
    submitting: boolean;
    subscriptionSuccess: boolean;
    subscriptionResponse: undefined;
    email: string;
    userSubscriptions: undefined;
    showSubscriptionsList: boolean;
    loadingSubscriptions: boolean;
} => ({
    loading: false,
    errorMessage: undefined,
    searchResults: undefined,
    submitting: false,
    subscriptionSuccess: false,
    subscriptionResponse: undefined,
    email: "",
    userSubscriptions: undefined,
    showSubscriptionsList: false,
    loadingSubscriptions: false,
});
